import IconAttention from '@/assets/icons/ic_logic-g-app_attention.svg'

import { Button } from '../ui/button'
import { Modal, ModalProps } from './Modal'

interface Props extends ModalProps {
  isTrial?: boolean
  onRequestClose: () => void
}

export const InformSubscriptionModal = ({
  isOpen,
  isTrial,
  onRequestClose,
  ...rest
}: Props): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      customStyles={{
        content: {
          padding: '48px 35px',
          width: '600px',
        },
      }}
      {...rest}
      onRequestClose={onRequestClose}
    >
      <h3 className="mb-[15px] mt-[10px] text-center text-2xl font-bold tracking-widest text-primary-text">
        {isTrial ? '再開できません' : 'お支払い情報を登録してください'}
      </h3>

      <p className="text-center text-[15px] font-medium tracking-widest text-secondary-text">
        {isTrial
          ? '主契約がトライアル中は、既存のプレイヤーの契約を再開することはできません。トライアル終了後に再度お手続きをお願いします。'
          : '通常プランを開始するためには、クレジットカードの登録が必要です。「支払い情報」からクレジットカード情報を入力してください。'}
      </p>

      <div className="mt-[40px] flex justify-center text-[#D7DDF3]">
        <IconAttention width={104} aria-hidden={true} />
      </div>

      <Button
        className="mx-auto mt-[40px] block w-[270px]"
        variant="secondary"
        onClick={onRequestClose}
      >
        とじる
      </Button>
    </Modal>
  )
}
